import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteAntibiogram } from './DeleteAntibiogram';
import { FormAntibiogram } from './FormAntibiogram';
import { Dialog } from 'primereact/dialog';

export const ModalAntibiogram = (props) => {

    const {
        modal, modalTitle, toggle, method, onChangeAntibiotics, antibioticsSelected,
        validaciones,
        antibiogram, antibiotics,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete,
        closeDialogA
    } = props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialogA}
            closable={true}
            modal
            blockScroll
            className='large-dialog'
        >

            {
                method === "create"
                    ? <FormAntibiogram
                        button={"Crear antibiograma"}
                        {...{ closeDialogA, loading, handleInputChange, antibiotics, onChangeAntibiotics, antibioticsSelected, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormAntibiogram
                            button={"Actualizar antibiograma"}
                            {...{ closeDialogA, loading, handleInputChange, antibiotics, onChangeAntibiotics, antibioticsSelected, validaciones, methodAction: saveUpdate, antibiogram, }} />
                        :
                        // <DeleteAntibiogram {...{ toggle, loading, antibiogram, saveDelete }} />
                        null
            }
        </Dialog>
    )
}
